import { render, staticRenderFns } from "./StructuralButton.vue?vue&type=template&id=5570594c&scoped=true&"
import script from "./StructuralButton.vue?vue&type=script&lang=ts&"
export * from "./StructuralButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570594c",
  null
  
)

export default component.exports